import { render, staticRenderFns } from "./VariantItem.vue?vue&type=template&id=278b78e8&scoped=true"
import script from "./VariantItem.vue?vue&type=script&lang=js"
export * from "./VariantItem.vue?vue&type=script&lang=js"
import style0 from "./VariantItem.vue?vue&type=style&index=0&id=278b78e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278b78e8",
  null
  
)

export default component.exports